// extracted by mini-css-extract-plugin
module.exports = {"table":"up-record_table_1ogLo","img":"up-record_img_3xj8M"};